import { FamilyService } from './../../../services/family/family.service';
import { isPlatformBrowser } from '@angular/common';
import { WebSiteUsersService } from './../../../services/webSiteUsers/webSiteUsers.service';
import { PdvService } from './../../../services/pdv/pdv.service';
import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef, OnDestroy, OnInit, Inject, PLATFORM_ID } from '@angular/core';
@Component({
    selector: 'footer-component',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.scss'],
    providers:[FamilyService]
})
export class FooterComponent implements OnDestroy, OnInit {
    pdv: any = {};
    subscr;
    subscriptions: Subscription[] = [];
    authorizedCities: any[] = [];
    email = '';
    loading = false;
    bounceOn: boolean = false;
    response = { result: '', msg: '' };
    @ViewChild('maplink') maplink: ElementRef;
    families: any[] = [];
    currentYear:number;
    constructor(
        private pdvService: PdvService,
        private webs: WebSiteUsersService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private familyService:FamilyService,
    ) {
        const subs2 = this.pdvService.pdv.subscribe(
            pdv => {
                this.pdv = pdv;
            }
        );
        const subs3 = this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        );
        this.subscriptions.push(subs2, subs3);
        let currentYear=new Date();
        this.currentYear=currentYear.getFullYear()
    }
    ngOnDestroy() {
        this.unsubscribe();
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    bounceOnFunction() {
        this.bounceOn = true;
        setTimeout(() => {
            this.bounceOn = false;
        }, 500)
    }
    subscribeToNewsLettre() {
        const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
        if (!regex.test(this.email)) {
            this.response = { result: 'error', msg: 'Merci d\'inscrire une adresse email valide' };
            setTimeout(
                () => {
                    this.response = { result: '', msg: '' };
                }, 1000
            );
        } else {
            this.loading = true;
            this.webs.subscribeToNewslettre(this.email).subscribe(response => {
                if (response.msg.indexOf('Thank you for subscribing!') > -1) {
                    response.msg = 'Merci de votre inscription !';
                }
                if (response.msg.indexOf('is already subscribed') > -1) {
                    response.msg = this.email + ' est déjà abonné à la newslettre';
                }
                if (response.msg.indexOf('Too many subscribe attempts') > -1) {
                    // tslint:disable-next-line:max-line-length
                    response.msg = 'Trop de tentatives d\'abonnement pour cette adresse e-mail. Veuillez réessayer dans environ 5 minutes. (# 6592)';
                }
                if (response.msg.indexOf('has too many recent signup requests') > -1) {
                    response.msg = 'Le destinataire ' + this.email + ' à trop de demandes d\'inscription récentes';
                }
                this.response = response;
                this.loading = false;
                this.email = '';
                setTimeout(
                    () => {
                        this.response = { result: '', msg: '' };
                    }, 1000
                );
            }, error => {
                console.error(error);
                this.loading = false;
                // this.error = 'Sorry, an error occurred.';
            });
        }
    }

    ngOnInit() {
        setTimeout(
            () => {
                let coords = this.pdv.address;
                if (coords) {
                    coords = coords.replace(/\ /g, '+');
                    this.maplink.nativeElement.setAttribute('href', this.GetMapUrl(coords));
                }
            }, 500
        );
        this.getFamiliesOfCarte();
    }

    GetMapUrl(q) {
        if (isPlatformBrowser(this.platformId)) {
            const ua = navigator.userAgent.toLowerCase();
            const windows8 = ua.indexOf('windows nt 6.2') > -1;
            const mobile = ua.indexOf('mobile') > -1 || ua.indexOf('wp7') > -1;
            const iPhone = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1;
            const android = ua.indexOf('android') > -1;
            const msie = ua.indexOf('msie') > -1;
            if (mobile && iPhone) { return ('http://maps.google.com/maps?q=' + q); } else if (mobile && android) { return ('geo:0,0?q=' + q); } else if (mobile && msie) { return ('maps:' + q); } else if (windows8) { return ('bingmaps:?q=' + q); } else {
                return ('http://maps.google.com/maps?q=' + q);
            }
        }
    }

    getFamiliesOfCarte() {
        this.familyService.getFamiliesOfCarte().subscribe(
            (families: any[]) => {
                this.families = families;
            }
        )
    }

}
